import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/tmbohen-silver.webp")